import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '../services/projects/projects.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

import swal from 'sweetalert2';


@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.css']
})
export class CampaignsComponent implements OnInit {

  campaigns: any;
  campaignForm: FormGroup;
  disableAddCampaign: boolean = false;
  is_edit_mode: boolean = false;
  currnet_campaign_id: any;

  constructor(
    private projectsService: ProjectsService, 
    private slimLoadingBarService: SlimLoadingBarService,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createCampaignForm();
    this.getCampaigns();
  }

  createCampaignForm(data?) {
    if (data) {
      this.campaignForm = this.formBuilder.group({
        name: [data.name || '', Validators.required],
        start_date: [data.start_date || '', Validators.required],
        end_date: [data.end_date || '', Validators.required]
      });
    } else {
      this.campaignForm = this.formBuilder.group({
        name: ['', Validators.required],
        start_date: ['', Validators.required],
        end_date: ['', Validators.required]
      });
    }
  }

  getCampaigns() {
    this.slimLoadingBarService.start();
    this.projectsService.getCampaigns().subscribe((res: any) => {
      this.slimLoadingBarService.complete();
      console.log(res);
      this.campaigns = res;
    }, err => {
      console.log(err);
      this.slimLoadingBarService.reset();
    });
  }

  addCampaign() {

  }

  editCampain(data, modal) {
    this.is_edit_mode = true;
    this.currnet_campaign_id = data.id;
    this.createCampaignForm(data);
    modal.open();
  }

  addCampaignModalOnClose() {
    this.is_edit_mode = false;
    this.currnet_campaign_id = null;
    this.campaignForm.reset();
  }


  addCampainSubmit(modal) {
    let payload = this.campaignForm.value;
    console.log(payload);
    this.disableAddCampaign = true;
    if (this.is_edit_mode) { 
      this.slimLoadingBarService.start();
      this.projectsService.updateCampaigns(this.currnet_campaign_id, payload).subscribe(
        (res: any) => {
          this.getCampaigns();
          swal("Woohoo!", "Updated Campaign succesfully!", "success");
          modal.close();
          this.disableAddCampaign = false;
          this.getCampaigns();
          this.is_edit_mode = false;
          this.currnet_campaign_id = null;
          this.campaignForm.reset();
        },
        err => {
          console.log(err);
          swal("Error!", "Couldn't create campaign succesfully!", "error");
          this.disableAddCampaign = false;
        }
      );
    } else {
      this.slimLoadingBarService.start();
      this.projectsService.createCampaigns(payload).subscribe((res: any) => {
      this.getCampaigns();
      swal('Woohoo!', 'Created Campaign succesfully!', 'success');
      modal.close();
      this.disableAddCampaign = false;
      this.getCampaigns();
      this.campaignForm.reset();
    }, err => {
      console.log(err);
      swal('Error!', 'Couldn\'t create campaign succesfully!', 'error');
      this.disableAddCampaign = false;
    });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/campaigns/campaigns.component.ts